import React, { useLayoutEffect, useState } from "react";

import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import useEventListener from "../../hooks/haiku/useEventListener";
import { ReactComponent as IconAccordionExpand18 } from "../../icons/icon/18/a-icon-accordeon-expand-18.svg";
import { ReactComponent as IconAccordionMinimize18 } from "../../icons/icon/18/a-icon-accordeon-minimize-18.svg";
import { ReactComponent as IconFilter24 } from "../../icons/icon/24/a-icon-filter-24.svg";
import { ReactComponent as IconSelect24 } from "../../icons/icon/24/a-icon-select-24.svg";
import { ReactComponent as IconSelectEmpty24 } from "../../icons/icon/24/a-icon-selectempty-24.svg";
import IconButton from "../button/iconButton";
import LinkButton from "../button/linkButton";
import FilterTag from "../filterTag/filterTag";

import "./filterDropdown.scss";

const FilterDropdown = ({
  children,
  headline = null,
  variant = null,
}) => {
  const [labels, setLabels] = useState([]);
  const [filterCriterionsTmp, setFilterCriterionsTmp] = useState([]);
  const [filterCriterionsState, setFilterCriterionsState] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [numberOfArticle, setNumberOfArticle] = useState(6);
  const [numberOfShowArticle, setNumberOfShowArticle] = useState(6);

  const resize = () => {
    if (window.innerWidth >= 576) {
      setNumberOfArticle(12);
      setNumberOfShowArticle(12);
    } else {
      setNumberOfArticle(6);
      setNumberOfShowArticle(6);
    }
  };

  const setFilterCriterion = (label) => {
    const indexOfRemove = filterCriterionsTmp.indexOf(label);

    if (indexOfRemove !== -1) {
      setFilterCriterionsTmp([...filterCriterionsTmp.filter((item) => item !== label)]);
    } else {
      setFilterCriterionsTmp([...filterCriterionsTmp, label]);
    }
  };

  const applyFilter = () => {
    setFilterCriterionsState([...filterCriterionsTmp]);
    setShowDropdown(false);
  };

  const filterChildren = () => {
    let articles;

    if (filterCriterionsState.length > 0) {
      articles = children.filter((child) => (
        filterCriterionsState.indexOf(child.props.category) !== -1
      ));
    } else {
      articles = children;
    }

    return articles;
  };

  useEventListener("resize", resize);

  useLayoutEffect(() => {
    const initLabels = [];

    children.forEach((child) => child.props.category
      && initLabels.indexOf(child.props.category) === -1
      && initLabels.push(child.props.category));

    setLabels(initLabels);

    resize();
  }, []);

  const articles = filterChildren();

  let colProps;

  switch (variant) {
    case "article-teaser":
      colProps = {
        sm: 6,
      };
      break;
    case "assets":
      colProps = {
        lg: 3,
        sm: 6,
      };
      break;
    case "form":
      colProps = {
        xs: 12,
      };
      break;
    default:
      colProps = {
        lg: 4,
        sm: 6,
      };
  }

  return (
    <div
      className={classNames(
        "filter-dropdown",
        { [`filter-dropdown--${variant}`]: variant },
      )}
    >
      {headline && (
        <div className="filter-dropdown__headline">
          {headline}
        </div>
      )}
      <div className="d-lg-flex">
        <LinkButton
          className="filter-dropdown__filter-button"
          onClick={() => {
            setShowDropdown((prevState) => !prevState);
          }}
        >
          <IconFilter24 /><FormattedMessage id="filter.category" />
        </LinkButton>
        {filterCriterionsState.length > 0 && (
          <div className="d-flex flex-wrap">
            {
              filterCriterionsState.map((tag) => (
                <FilterTag
                  key={tag.id}
                  onClick={() => {
                    setFilterCriterion(tag);
                    applyFilter();
                  }}
                  variant="primary"
                >
                  {tag}
                </FilterTag>
              ))
            }
          </div>
        )}
      </div>
      <Row className="position-relative">
        <Col md={6} xl={4} className={classNames("filter-dropdown__menu", { "d-none": !showDropdown })}>
          <div>
            <div className="filter-dropdown__menu-headline">
              <FormattedMessage id="filter.categories_selected" values={{ count: filterCriterionsTmp.length }} />
            </div>
            <div className="filter-dropdown__label-container">
              {
                labels.map((label) => (
                  <div
                    className={classNames(
                      "filter-dropdown__label",
                      { active: filterCriterionsTmp.indexOf(label) !== -1 },
                    )}
                    key={label.id}
                    onClick={() => {
                      setFilterCriterion(label);
                    }}
                    role="presentation"
                  >
                    {label} {
                    (filterCriterionsTmp.indexOf(label) !== -1)
                      ? <IconSelect24 />
                      : <IconSelectEmpty24 />
                  }
                  </div>
                ))
              }
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <Button onClick={() => applyFilter()} size="sm" variant="primary">
                <FormattedMessage id="filter.apply_filter" />
              </Button>
              {
                filterCriterionsTmp.length > 0
                  ? (
                    <LinkButton
                      onClick={() => {
                        setFilterCriterionsTmp([]);
                      }}
                      variant="normal"
                    >
                      <FormattedMessage id="filter.reset" />
                    </LinkButton>
                  )
                  : (
                    <LinkButton
                      onClick={() => {
                        setShowDropdown((prevState) => !prevState);
                      }}
                      variant="normal"
                    >
                      <FormattedMessage id="filter.cancel" />
                    </LinkButton>
                  )
              }
            </div>
          </div>
        </Col>
      </Row>
      <Row className="filter-dropdown__article-container">
        {variant === "form" && (
          <Col xs={12} className="filter-dropdown__list-columns">
            <Row>
              <Col xl={2} className="typo-label">
                <FormattedMessage id="listsection.name" />
              </Col>
              <Col xl={4} className="typo-label">
                <FormattedMessage id="listsection.description" />
              </Col>
              <Col xl={3} className="typo-label">
                <FormattedMessage id="listsection.category" />
              </Col>
              <Col xl={3} className="typo-label">
                <FormattedMessage id="listsection.actions" />
              </Col>
            </Row>
          </Col>
        )}
        {
          articles.map((child, index) => (
            (index < numberOfShowArticle) && (
              (index === 0 && child.props.highlight)
                ? (
                  <Col
                    key={child.props.category + index.toString()}
                    xs={12}
                  >
                    {child}
                  </Col>
                )
                : (
                  <Col
                    key={child.props.category + index.toString()}
                    {...colProps}
                  >
                    {child}
                  </Col>
                )
            )
          ))
        }
      </Row>
      {articles.length > numberOfArticle && (
        <div className="filter-dropdown__button-container">
          {numberOfShowArticle < articles.length
            ? (
              <IconButton
                variant="primary"
                className="filter-dropdown__pagination"
                onClick={() => {
                  setNumberOfShowArticle(numberOfShowArticle + numberOfArticle);
                }}
              >
                <FormattedMessage id="filter.show_more" /> <IconAccordionExpand18 />
              </IconButton>
            )
            : (
              <IconButton
                variant="primary"
                className="filter-dropdown__pagination"
                onClick={() => {
                  resize();
                }}
              >
                <FormattedMessage id="filter.show_less" /> <IconAccordionMinimize18 />
              </IconButton>
            )}
        </div>
      )}
    </div>
  );
};

FilterDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  headline: PropTypes.string,
  variant: PropTypes.oneOf(["article-teaser", "assets", "form"]),
};

export default FilterDropdown;
